import { DeliveryService } from '../../service/DeliveryService/delivery.service';
import { FileUpload } from './../../service/FileUpload/fileUpload';
import { FileUploadService } from './../../file-upload.service';

import { Router, ActivatedRoute } from '@angular/router';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Component, OnInit, ViewChild } from '@angular/core';

@Component({
  selector: 'app-edit-delivery-partner',
  templateUrl: './edit-delivery-partner.component.html',
  styleUrls: ['./edit-delivery-partner.component.scss']
})
export class EditDeliveryPartnerComponent implements OnInit {
  members:any;
  addForm:any;
  image="https://i.ibb.co/4774fvj/profileimg.png";
  msg1:string;currentUpload:any;
msg="enter valid";
delete1:boolean=false;
selectedFile:File=null;UserProfilePath:string='USERS';
editId:any;
    constructor(private route:Router,private ApiService:DeliveryService, private activeRoute:ActivatedRoute,private UploadService:FileUploadService) {
      this.addForm={
        name: "",
        image: {url:'https://www.linuxtrainingacademy.com/wp-content/plugins/all-in-one-seo-pack/images/default-user-image.png'},
        status:true
      }
this.editId=this.activeRoute.snapshot.paramMap.get("id");
this.getDeliveryPartnerDetail();
     }
     

  ngOnInit(): void {
  }
  getDeliveryPartnerDetail()
  {
this.ApiService.getDeliveryPatnersDetail(this.editId).then((res)=>
{
  this.addForm=res;
  console.log(this.addForm)
})
  }
  showPreview(event:any)
  {
    if(event.target.files && event.target.files[0])
    {
      const reader=new FileReader();
        reader.onload=(e:any)=>this.addForm.image.url=e.target.result;
        reader.readAsDataURL(event.target.files[0]);
        this.selectedFile=event.target.files[0];
        console.log(this.selectedFile);
      this.detectFiles();
    }
    else
    {
      this.addForm.image.url="https://www.linuxtrainingacademy.com/wp-content/plugins/all-in-one-seo-pack/images/default-user-image.png";
    }
  }
  detectFiles() {
    // this.deletePreviousFile();
    // this.addForm.image={'url':"https://i.ibb.co/4774fvj/profileimg.png"}
    // this.currentUpload=null;
    this.uploadSingle();
  } 
  uploadSingle()
  {
    this.currentUpload = new FileUpload(this.selectedFile);
    console.log(this.currentUpload);
    this.UploadService.pushUpload(this.currentUpload,this.UserProfilePath).then((res) => {
      this.addForm.image = res;
      this.delete1=true
      
      this.currentUpload=null;
      console.log(this.addForm.image);
      console.log(this.UploadService.uploadPercentage);
    });
  }
  delete()
  {
    this.deletePreviousFile();
    
  }
  deletePreviousFile()
  {
    if(this.addForm.image.name!=undefined)
    {
      this.UploadService.deleteUpload(this.addForm.image,this.UserProfilePath).then((res)=>
      {
        console.log('Previous Image Deleted');
        this.addForm.image.url="https://www.linuxtrainingacademy.com/wp-content/plugins/all-in-one-seo-pack/images/default-user-image.png";
this.delete1=false
      })
    }
  }
  updateMember()
  {
    // if(this.addForm.paymentOption[0]==0)
    // {
    // const index: number = this.addForm.paymentOption.indexOf(0);
    // if (index !== -1) {
    //     this.addForm.paymentOption.splice(index, 1);
    // }}      
   this.ApiService.EditDeliveryPatnersDetail(this.editId,this.addForm).then(
      (res)=>
      {
        console.log(res);
        console.log("delivery boy is edited");
        this.route.navigateByUrl('/dashboard/deliveryList')
      }
    );

  console.log(this.addForm);
    }


}